//  <FileHeader xmlns="http://www.gordic.cz/shared/file-header/v_1.0.0.0">
//    <Name>        Gordic.Adm.WebControls.SeznamAdePovFunkcePlanyDesigner.ts             </Name>
//    <Description>                                                             </Description>
//    <Author>      JKLUSACEK                                                      </Author>
//    <Copyright>   � GORDIC spol. s r. o. 1993-2021                            </Copyright>
//    <Created>     2021-10-20                      </Created>
//  </FileHeader>

//This source code was auto-generated by ADT03-Generator, Version=486.16.5
//AdtGeneratorConfig:[ T:(srvvrfu) GID:(Web.Set.Des.Ts) V1:(ixs_fun,ixp_den,aktivita,dat_od,dat_do,dat_zmena,zmenu_prov) V2:() K1:() K2:() K3:() ]


/// <reference path="../../Base/SeznamBase.ts" />

namespace Gordic.Adm.WebControls {

    /**
     * SeznamAdePovFunkcePlanyDesigner
     * 
     * @author JKLUSACEK
     * @since 482.1.0.119
     */
    export class SeznamAdePovFunkcePlanyDesigner extends SeznamBase {

        /** z detail okna p�edan� atribut pro filtr seznamu */
            /** PK - ixs_fun */
            public ixs_fun: string;
            /** PK - ixp_den */
            public ixp_den: string;

        /** isl view gridu */
        view: Gordic.Isl.View<Gordic.AdmIsl.Interface.GAdePovFunkcePlanyListDto>;

        /** vytvo�it formul�� filtru - panel */
        static createFilter(that: GContentType<SeznamAdePovFunkcePlanyDesigner>, ixs_fun: string,ixp_den: string  ): JQuery<HTMLElement> {
            // vytvorim form a na nem policka
            let v_form = this.createFilterForm(that, ixs_fun, ixp_den);
            v_form.addRow("jres:33000146").addField("gselectbox", Gordic.Prefabs.Select.admSrvspla(), {
                dropdown: false,
                /*graphicInput: "oninput",*/
                name: "ixp_den",
                initialValue: ixp_den ? { ixs_pla: ixp_den } : null,
                model: "model.ixp_den=value.ixs_pla",
                disabled: ixp_den ? true : false,
            })
            // vytvorim panel a umistim jej do hlavniho DIVu
            let v_filter = SeznamBase.createFilterBase(that, v_form, true, this.applyAction, {
                hardDefaultFilter: {
                    ixp_den: ixp_den,
                    ixs_fun: ixs_fun
                }
            });

            //v_filter.gfilterpanel("applyFilter");         // toto vede k okam�it�mu na�ten� dat do seznamu podle nastaven�ho filtru

            return (v_filter);
        } // createFilter

        /** vytvo�it formul�� filtru - vytvo�� tam filtra�n� pol��ka */
        static createFilterForm(that: GContentType<SeznamAdePovFunkcePlanyDesigner>, ixs_fun: string,ixp_den: string ): Forms.Form {

            // vytvo��m form
            var v_filterForm = SeznamBase.createFilterFormBase(that);

            // p�id�m do n�j pol��ka

            return v_filterForm;
        } // createFilterForm

        static applyAction(that: GContentType<SeznamAdePovFunkcePlanyDesigner>, ev, ctx): any {
            var filterObj = {
                ixp_den: SeznamBase.filterContains(ctx.filter, "ixp_den")
            }
            that.view = new Gordic.Isl.View(that.isl.AdePovFunkcePlany.list({ filters: filterObj }));
            that.grid.ggrid("setData", that.view);
        }

        /**
         * SeznamAdePovFunkcePlanyDesignerInit
         * 
         * @param {GContentType<SeznamAdePovFunkcePlanyDesigner>} that
         */
        static SeznamAdePovFunkcePlanyDesignerInit(that: GContentType<SeznamAdePovFunkcePlanyDesigner>, ixs_fun: string,ixp_den: string ) {
            this.SeznamBaseInit(that);
            that.filter = this.createFilter(that, ixs_fun,ixp_den);
            that.gridFormat = this.createGridFormatByDataListDescription(that);
            that.gridSearchColumns = this.createGridSearchColumnsByDataListDescription(that);
            this.LoadData(that, ixs_fun, ixp_den);

        } // SeznamAdePovFunkcePlanyDesignerInit

        static LoadData(that: GContentType<SeznamAdePovFunkcePlanyDesigner>, ixs_fun: string, ixp_den: string) {
            var filterObj: any = {}
            if (ixp_den) {
                new Gordic.Data.Readers.AdmSrvspla().getData({ ixs_pla: ixp_den }).done((o) => {
                    that.filter.findFields("ixp_den").gfield("setInitial", o[0]);
                })
                filterObj.ixp_den = ixp_den;
            }
            that.view = new Gordic.Isl.View(that.isl.AdePovFunkcePlany.list({ filters: filterObj }), { filterPanel: that.filter, startEmpty: false, });       // propojen� ovl�dac�ho prvku gridu se zdrojem dat - a s filter panelem
        }

    }
}
